import initAjaxSelect2 from "../services/init-ajax-select2";
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";


export default () => ({
    selectedCourse: 0,
    selectedDivision: 0,
    childDivision: false,
    archiveData: false,
    personalReportsResults: [],
    isLoading: false,
    isReport: false,
    isDivisionReport: false,
    userId: 0,
    divisionReportData: "",
    divisionReportColumns: "",
    errors: [],
    reportDateTime: "",
    typeReport: "division",
    openResultSectionId: 0,
    isPersonalArchiveReport: false,
    personalArchiveReportData: "",
    personalArchiveReportColumns: "",
    personalArchiveReportDateTime: "",
    isTraineePortal: false,


    async init() {
        this.$watch("typeReport", (value) => {
            this.isReport = false
            this.personalReportsResults = []
            this.isDivisionReport = false
        })

        try {
            this.isTraineePortal = this.$root.dataset.isTraineePortal === "1";
            this.userId = this.$root.dataset.currentUserId

            Date.prototype.today = function () {
                return ((this.getDate() < 10) ? "0" : "") + this.getDate() + "/" + (((this.getMonth() + 1) < 10) ? "0" : "") + (this.getMonth() + 1) + "/" + this.getFullYear();
            }

            Date.prototype.timeNow = function () {
                return ((this.getHours() < 10) ? "0" : "") + this.getHours() + ":" + ((this.getMinutes() < 10) ? "0" : "") + this.getMinutes() + ":" + ((this.getSeconds() < 10) ? "0" : "") + this.getSeconds();
            }

            jQuery(() => {
                this.select2Courses = jQuery('#reportCourses').select2(initAjaxSelect2(
                    `${rozetka_learnpress_global.restApi.url}courses`,
                    {user_id: this.userId},
                    rozetka_learnpress_global.restApi.nonce
                ));
                this.select2Divisions = jQuery('#reportDivision').select2(initAjaxSelect2(
                    `${rozetka_learnpress_global.restApi.url}divisions`,
                    {user_id: this.userId},
                    rozetka_learnpress_global.restApi.nonce
                ));
                this.select2Courses.on("select2:select", (event) => {
                    this.selectedCourse = event.target.value
                })
                this.select2Divisions.on("select2:select", (event) => {
                    this.selectedDivision = event.target.value
                })
                this.$watch("selectedCourse", (value) => {
                    this.select2Courses.val(value).trigger("change")
                })
                this.$watch("selectedDivision", (value) => {
                    this.select2Divisions.val(value).trigger("change")
                })
            })
        } catch (error) {
            console.error(error)
        }
    },

    async formSubmit() {
        this.isDivisionReport = false
        this.isReport = false
        this.isPersonalArchiveReport = false
        this.isLoading = true
        this.errors = []
        try {
            const store = this.$store?.TestsReportStore ?? {};
            const selectedCourseId = store?.selectedCourse;

            if (this.typeReport === 'personal') {
                const employeeId = store?.selectedEmployeeId ?? null;
                const selectedUserId = store?.selectedUserId ?? null;

                if (!selectedCourseId) {
                    throw new Error('Оберіть курс');
                }

                if (this.isTraineePortal) {
                    if (!selectedUserId) {
                        throw new Error('Оберіть користувача');
                    }
                } else if (!employeeId) {
                    throw new Error('Оберіть співробітника');
                }

                const requestBody = {
                    course_id: selectedCourseId,
                    archive_data: this.archiveData,
                };

                if (this.isTraineePortal) {
                    requestBody.user_id = selectedUserId;
                } else {
                    requestBody.employee_id = employeeId;
                }

                const response = await fetch(`${rozetka_learnpress_global.restApi.url}report-personal`,
                    {
                        method: 'POST',
                        headers: {
                            "Accept": "application/json",
                            "Content-Type": "application/json",
                            "X-WP-Nonce": rozetka_learnpress_global.restApi.nonce
                        },
                        body: JSON.stringify(requestBody)
                    })

                const {success, message, data} = await response.json()

                if (!success) throw new Error(message)

                if (this.archiveData) {
                    this.personalArchiveReportData = JSON.stringify(data.dataset)
                    this.personalArchiveReportColumns = JSON.stringify(data.columns)

                    const currentDate = new Date()
                    this.personalArchiveReportDateTime = currentDate.today() + " " + currentDate.timeNow()

                    this.isPersonalArchiveReport = true
                } else {
                    this.personalReportsResults = data
                    this.isReport = true
                }
            } else {
                const response = await fetch(`${rozetka_learnpress_global.restApi.url}report-division`,
                    {
                        method: 'POST',
                        headers: {
                            "Accept": "application/json",
                            "Content-Type": "application/json",
                            "X-WP-Nonce": rozetka_learnpress_global.restApi.nonce
                        },
                        body: JSON.stringify({
                            course_id: selectedCourseId,
                            division_id: store?.selectedDivisions?.[0],
                            child_division: this.childDivision,
                        })
                    })

                const {success, message, data} = await response.json()

                if (!success) throw new Error(message)

                this.divisionReportData = JSON.stringify(data.data)
                this.divisionReportColumns = JSON.stringify(data.columns)

                const currentDate = new Date()
                this.reportDateTime = currentDate.today() + " " + currentDate.timeNow()

                this.isDivisionReport = true
            }
        } catch (error) {
            this.errors.push(error.message)
            console.error(error)
        } finally {
            this.isLoading = false
        }
    },

    handleOpenResultQuestionButton(id) {
        this.openResultSectionId = this.openResultSectionId === id ? 0 : id
    },

    generateAnswerProvided(question, questionId, answerOptions, status = 'success') {
        let text = ""
        let icon = "✅"

        if (question.answered === "") {
            return {
                icon: "🔘",
                text: "Відповідь не надано"
            }
        }

        if (status === 'failed') {
            icon = "❌"
        }

        if (Array.isArray(question.answered)) {
            question.answered.map((answer) => {
                const title = Object.values(answerOptions[questionId] ?? {})
                    .find(opt => opt.value === answer)
                    ?.title;
                // const title = question?.options?.find((option) => option.value === answer)?.title
                text += title + "; ";
            })
        } else {
            // text += question?.options?.find((option) => option.value === question.answered)?.title
            text = Object.values(answerOptions[questionId] ?? {})
                .find(opt => opt.value === question.answered)
                ?.title;
        }

        return {
            icon,
            text
        }
    },

    generateCorrectAnswers(questionId, answerOptions) {
        let text = "";

        Object.values(answerOptions[questionId] ?? {}).map(option => {
            if (option.is_true === 'yes') {
                text += option.title + "; "
            }
        });

        return {
            icon: "☑️",
            text
        }
    },

    generateAnswerStatus(question) {
        if (question.correct) {
            return "success"
        }

        if (question.answered === "") {
            return "empty"
        }

        return "failed"
    },

    resetForm() {
        this.selectedCourse = 0;
        this.selectedDivision = 0;
        this.personalReportsResults = [];
        this.isReport = false;
        this.isDivisionReport = false;
        this.isPersonalArchiveReport = false;
        this.errors = [];
        this.$store.TestsReportStore.selectedEmployees = [];
        this.$store.TestsReportStore.selectedEmployeeId = null;
        this.$store.TestsReportStore.selectedUsers = [];
        this.$store.TestsReportStore.selectedUserId = null;
        this.$store.TestsReportStore.selectedCourse = 0;
        this.$store.TestsReportStore.selectedDivisions = [];
    },

    async generatePersonalQuizReport(data) {
        const body = []

        body.push([
            {text: 'Питання', fontSize: 10, margin: [10, 5, 10, 5]},
            {text: 'Надана віповідь', fontSize: 10, margin: [10, 5, 10, 5]},
            {text: 'Правильна відповідь', fontSize: 10, margin: [10, 5, 10, 5]}
        ])

        const emojiColors = {
            'success': 'green',
            'failed': 'red',
            'empty': 'grey'
        }

        for (const [index, question] of Object.entries(data.quiz_result.questions)) {
            const answerStatus = this.generateAnswerStatus(question)
            const answerProvided = this.generateAnswerProvided(question, index, data.quiz_answer_options, answerStatus);
            const correctAnswers = this.generateCorrectAnswers(index, data.quiz_answer_options);

            body.push([
                {text: data.question_titles[index], fontSize: 10, margin: [10, 5, 10, 5]},
                {
                    text: [{text: answerProvided.icon, font: 'NotoEmoji', color: emojiColors[answerStatus]}, ' ', answerProvided.text],
                    fontSize: 10,
                    margin: [10, 5, 10, 5]
                },
                {
                    text: [{text: correctAnswers.icon, font: 'NotoEmoji', color: "#8eaec9"}, ' ', correctAnswers.text],
                    fontSize: 10,
                    margin: [10, 5, 10, 5]
                }
            ])
        }

        const rozetkaLogo = await this.getBase64ImageFromURL('/wp-content/uploads/2025/02/REDmainlogo_black.svg')

        const content = [
            {image: rozetkaLogo, width: 300},
            {
                text: 'Згенеровано за допомогою інструментів звітності порталу',
                color: '#777',
                fontSize: 8,
                margin: [0, -10, 0, 30]
            },
            {text: 'Звіт по тесту', style: 'header'},
            {
                text: [{text: 'Дата формування звіту: ', style: 'boldText'}, this.getDateTimeNow()],
                fontSize: 10,
                margin: [0, 3]
            },
            {text: [{text: 'Курс: ', style: 'boldText'}, data.course_title], fontSize: 10, margin: [0, 3]},
            {text: [{text: 'Назва тесту: ', style: 'boldText'}, data.quiz_title], fontSize: 10, margin: [0, 3]},
            {
                text: [{text: 'Дата завершення тесту: ', style: 'boldText'}, data.quiz_end_time],
                fontSize: 10,
                margin: [0, 3]
            },
            {text: [{text: 'ПІБ: ', style: 'boldText'}, data.user_full_name], fontSize: 10, margin: [0, 3]},
            {text: [{text: 'Результат: ', style: 'boldText'}, data.quiz_result.result], fontSize: 10, margin: [0, 3]},
            {
                layout: 'lightHorizontalLines',
                table: {
                    headerRows: 1,
                    widths: ['*', '*', '*'],
                    body
                },
                margin: [0, 10, 0, 15]
            },
        ]

        if (data.course_signature) {
            content.push(
                {
                    text: [
                        'Наданий електронний рукописний підпис підтверджує, що, працівник пройшов(ла) навчання в електронному вигляді на навчальному порталі',
                        {text: ' ROZETKA University', style: 'boldText'},
                        ', ознайомився(лась) з матеріалами курсу та успішно завершив(ла) перевірку знань шляхом проходження тесту.'
                    ], color: '#a6a5a5', fontSize: 8, margin: [0, 10, 0, 10]
                })

            content.push({
                alignment: 'center',
                columns: [
                    {
                        width: 'auto',
                        text: 'Підпис:',
                        bold: true,
                        fontSize: 16,
                        margin: [0, 50, 120, 0]
                    },
                    {
                        image: data.course_signature,
                        width: 120
                    }
                ],
                margin: [100, 0, 100, 0]
            })
        }

        const docDefinition = {
            content,
            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                    alignment: 'center'
                },
                boldText: {bold: true}
            }
        };

        const fonts = {
            NotoEmoji: {
                normal: 'https://cdn.jsdelivr.net/gh/zjaco13/Noto-Emoji-Monochrome@24d8485dc7eeda9ec8d08788dfacad75127aebc7/fonts/NotoEmoji-Medium.ttf',
                bold: 'https://cdn.jsdelivr.net/gh/zjaco13/Noto-Emoji-Monochrome@24d8485dc7eeda9ec8d08788dfacad75127aebc7/fonts/NotoEmoji-Medium.ttf',
                italics: 'https://cdn.jsdelivr.net/gh/zjaco13/Noto-Emoji-Monochrome@24d8485dc7eeda9ec8d08788dfacad75127aebc7/fonts/NotoEmoji-Medium.ttf',
                bolditalics: 'https://cdn.jsdelivr.net/gh/zjaco13/Noto-Emoji-Monochrome@24d8485dc7eeda9ec8d08788dfacad75127aebc7/fonts/NotoEmoji-Medium.ttf',
            },
            Roboto: {
                normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
                bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
                italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
                bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
            }
        }

        pdfMake.createPdf(docDefinition, null, fonts).download(`Звіт_${data.user_full_name.replace(' ', '_')}_${data.quiz_title.replace(' ', '_')}.pdf`);
    },

    getDateTimeNow() {
        const m = new Date()
        const month = (m.getMonth() + 1) < 10 ? '0' + (m.getMonth() + 1) : (m.getMonth() + 1)
        const day = m.getDate() < 10 ? '0' + m.getDate() : m.getDate()

        return m.getFullYear() + "-" + month + "-" + day
    },

    getBase64ImageFromURL(url) {
        return new Promise((resolve, reject) => {
            const img = new Image()
            img.setAttribute("crossOrigin", "anonymous")
            img.onload = () => {
                const canvas = document.createElement("canvas")
                canvas.width = img.width
                canvas.height = img.height
                const ctx = canvas.getContext("2d")
                ctx.drawImage(img, 0, 0)
                const dataURL = canvas.toDataURL("image/png")
                resolve(dataURL)
            }
            img.onerror = (error) => {
                reject(error)
            }
            img.src = url
        })
    }
})
